import React from "react";
import { authReducer, initialState } from "./reducer";
import useThunkReducer from "../../HOC/useThunkReducer";
import useModal from "../../HOC/useModal";
import AuthModal from "../../Auth/AuthModal";


export const AuthContext = React.createContext();

const AuthContextWrapper = ({ children }) => {
  const [authState, dispatch] = useThunkReducer(
    authReducer,
    initialState,
);

  const { openModal, closeModal, modal } = useModal({
      backgroundClose: true
  });

  const userShouldAuthenticate = ({
      loginHeader = null,
      signupHeader = null,
  } = {}) => {
    if (!authState?.isAuthenticated) {
      openModal(
        <AuthModal loginHeader={loginHeader} signupHeader={signupHeader} closeModal={closeModal}>
        </AuthModal>
      );
    }
  };

  const value = {
    userShouldAuthenticate,
    authState,
    dispatch,
  };
  return (
    <AuthContext.Provider value={value}>
      <>
        {modal}
        {children}
      </>
    </AuthContext.Provider>
  );
};

export default AuthContextWrapper;
